import React, {FunctionComponent, DetailedHTMLProps} from "react";

interface ButtonProps extends DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  kind: 'primary' | 'ghost';
}

const Button: FunctionComponent<ButtonProps> = ({children, className, kind, ...rest}) => {
  return (
    <button
      className={cn(kind, className)}
      {...rest}
    >{children}</button>
  )
}

export default Button;

function cn(kind: ButtonProps['kind'], className?: string)  {
  return `border rounded py-1 px-4${
    kind === 'primary' ? ' border-blue-500' : (
    kind === 'ghost' ? ' border-grey-800' : ' border-none')
  }${
    kind === 'primary' ? ' bg-blue-500' : ''
  }${
    kind === 'primary' ? ' text-white' : ''
  }${
    className ? ' ' + className : ''
  }`
}
